<template>
  <div>
    <div class="item" v-for="(item, index) in items" :key="index" v-if="isLogin(item.isLogin) && !item.isMobile" >
      <div v-if="item.subitems"
      @click.stop="item.link == 'parent' ? toggle(index) : (!item.link == 'disable' && !item.link == 'default') ? redirect(item.link, index) : ''"
      :class="['sidebarDesktop__item', isActive.includes(index) && ((!item.link == 'disable' && !item.link == 'default') || item.link == 'parent') ? 'active' : '']">
        <i :class="item.icon"></i>
        <h5 class="sidebarDesktop__item__title">{{item.title | capitalizing}}</h5>
        <div class="sidebarDesktop__item__chevron">
          <i :class="isActive.includes(index) ? 'icon-chevronup':'icon-chevrondown'"></i>
        </div>
      </div>
      <div
      v-else-if="item.link == 'default'"
      :class="['sidebarDesktop__item', isActive.includes(index) ? 'active' : '']">
        <i :class="item.icon"></i>
        <h5 class="sidebarDesktop__item__title">{{item.title | capitalizing}}</h5>
      </div>
      <div
      v-else-if="item.link == 'disable'"
      :class="['sidebarDesktop__item', isActive.includes(index) ? 'active' : '']">
        <i :class="item.icon"></i>
        <h5 class="sidebarDesktop__item__title">{{item.title | capitalizing}}</h5>
      </div>
      <div
      v-else-if="item.link == 'parent'"
      @click.stop="toggle(index)"
      :class="['sidebarDesktop__item', isActive.includes(index) ? 'active' : '']">
        <i :class="item.icon"></i>
        <h5 class="sidebarDesktop__item__title">{{item.title | capitalizing}}</h5>
      </div>
      <div v-else-if="!item.subitems"
      @click.stop="item.link ? redirect(item.link, index) : redirectToPath(item.path, index)"
      :class="['sidebarDesktop__item', isActive.includes(index) ? 'active' : '']">
        <i :class="item.icon"></i>
        <h5 class="sidebarDesktop__item__title">{{item.title | capitalizing}}</h5>
      </div>
      <template>
        <div v-if="item.subitems">
          <adx-sub-item :parent="item" :key="`i${index}`" :subitems="item.subitems" v-if="isActive.includes(index)" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Badge from '@/components/Badge'
import SubItem from '@/components/SideBar/Desktop/Item/SubItem'

export default {
  name: 'adx-sidebar-item',
  props: {
    items: {
      required: false
    }
  },
  components: {
    'adx-badge': Badge,
    'adx-sub-item': SubItem
  },
  data() {
    return {
      isActive: []
    }
  },
  beforeMount() {
    this.checkActive()

  },
  methods: {
    redirect(linkName, index) {
      this.toggle(index)
      this.$router.push({ name: linkName })
    },
    redirectToPath(pathName, index) {
      this.toggle(index)
      this.$router.push({ path: pathName })
    },
    toggle(index) {
      if (this.isActive.includes(index)) {
        this.isActive.pop()
      } else {
        this.isActive.pop()
        this.isActive.push(index)
      }
    },
    isLogin(isRequired) {
      const token = this.$store.getters.token
      const isSuperuser = this.$store.getters.isSuperuser
      const staff = this.$store.getters.isStaff
      const groups = this.$store.getters.groups.split(',')
      if(isRequired && token) {
        if (isSuperuser) {
          return true
        }
        if (isRequired === 'staff' && !staff) {
          return false
        }
        if (isRequired === 'superuser' && !isSuperuser) {
          return false
        }
        if (isRequired === 'usermanager' && !groups.includes('user_manager')) {
          return false
        }
        if (isRequired === 'opsspv' && !groups.includes('OpsSupervisor')) {
          return false
        }
        if (isRequired === 'GA' && !groups.includes('GA')) {
          return false
        }
        if (isRequired === 'opsspvorga' && !groups.includes('OpsSupervisor') && !groups.includes('GA')) {
          return false
        }
        return true
      }else if (isRequired && token == '') {
        return false
      }else {
        return true
      }
    },
    checkActive() {
      let link = this.$route.name
      let activeIndex = null
      this.items.forEach(function (item, index) {
        if (item.link == link) {
          activeIndex = index
        }
        if (item.subitems) {
          item.subitems.forEach(function (subitem) {
            if (subitem.link == link) {
              activeIndex = index
            }
          })
        }
      })
      if (activeIndex !== null) {
        this.isActive.push(activeIndex)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>